export const sendEventGA = (eventName: string, params: Record<string, any>): void => {
  window.dataLayer.push({ event: 'custom', eventName, ...params })
}
